/* eslint-disable quotes */
import { CLIENT_NAME } from '@/utils'
import type { TypeLang, TypeJsonLdAboutUsOriginsData } from '@/schema'
import { buildUrl, buildBreadcrumb, getIetfLang, BREADCRUMB_HOME } from './_url'
import { buildOrganization } from './_organization'

const BREADCRUMB_ABOUT: Record<TypeLang, string> = {
  es: 'Sobre nosotros',
  en: 'About us'
}

const BREADCRUMB_ORIGINS: Record<TypeLang, string> = {
  es: 'Orígenes',
  en: 'Origins'
}

const KNOWS_ABOUT: Record<TypeLang, string[]> = {
  es: ['Fornituras para la moda', 'Pasamanería', 'Mercería'],
  en: ['Fashion haberdashery', 'Passementerie', 'Haberdashery']
}

export function jsonLdAboutUsOrigins(data: TypeJsonLdAboutUsOriginsData, locale: TypeLang) {
  const url = buildUrl(locale, '/about-us/origins')

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        "@id": `${url}/#webpage`,
        "url": url,
        "name": data.name,
        "description": data.description,
        "inLanguage": getIetfLang(locale),
        "isPartOf": {
          "@id": `${buildUrl(locale)}/#website`
        },
        "about": {
          "@id": `${buildUrl(locale)}/#organization`
        },
        "breadcrumb": {
          "@id": `${url}/#breadcrumb`
        }
      },
      {
        ...buildBreadcrumb(locale, [
          { name: BREADCRUMB_HOME[locale], path: '' },
          { name: BREADCRUMB_ABOUT[locale], path: '/about-us' },
          { name: BREADCRUMB_ORIGINS[locale], path: '/about-us/origins' }
        ]),
        "@id": `${url}/#breadcrumb`
      },
      {
        ...buildOrganization(locale, 'brief'),
        "@id": `${buildUrl(locale)}/#organization`,
        "description": data.description,
        "foundingDate": "1986",
        "foundingLocation": {
          "@type": "Place",
          "name": "Valladolid, Spain"
        },
        "knowsAbout": KNOWS_ABOUT[locale],
        "alternateName": `${CLIENT_NAME}`
      }
    ]
  }

  return JSON.stringify(schema)
}
